import { useEffect, useState, useRef } from "react"
import { auth, db } from "../firebase"
import { doc, getDoc, updateDoc } from "firebase/firestore"
import { useNavigate } from "react-router-dom"
import "./Explore.css"

function Explore(){

const [user,setUser] = useState(null)
const [userData,setUserData] = useState(null)
const [loading,setLoading] = useState(true)
const [loadedImages,setLoadedImages] = useState({})
const [search,setSearch] = useState("")
const [animate,setAnimate] = useState(false)

const navigate = useNavigate()
const lastTickRef = useRef(null)
const bufferedSecondsRef = useRef(0)

useEffect(()=>{

const init = async()=>{

const currentUser = auth.currentUser

if(!currentUser){
navigate("/login",{replace:true})
return
}

const snap = await getDoc(doc(db,"users",currentUser.uid))

if(!snap.exists()){
navigate("/dashboard",{replace:true})
return
}

setUser(currentUser)
setUserData(snap.data())
setLoading(false)

lastTickRef.current = Date.now()

}

init()

},[navigate])


useEffect(()=>{

if(!user) return

const userRef = doc(db,"users",user.uid)

const flushTime = async()=>{

if(!lastTickRef.current) return

const now = Date.now()
const diffSeconds = Math.floor((now-lastTickRef.current)/1000)

if(diffSeconds<=0) return

bufferedSecondsRef.current += diffSeconds
lastTickRef.current = now

if(bufferedSecondsRef.current < 30) return

const minutesToSave = bufferedSecondsRef.current/60
bufferedSecondsRef.current = 0

const todayKey = new Date().toLocaleDateString("en-CA")

const snap = await getDoc(userRef)

if(!snap.exists()) return

const data = snap.data()
const screen = data.screentime || {}

const updatedScreen = {
...screen,
[todayKey]: parseFloat(((screen[todayKey]||0)+minutesToSave).toFixed(2))
}

const updatedTotal = parseFloat(((data.totalScreenTime||0)+minutesToSave).toFixed(2))

await updateDoc(userRef,{
screentime:updatedScreen,
totalScreenTime:updatedTotal
})

setUserData(prev=>({
...prev,
screentime:updatedScreen,
totalScreenTime:updatedTotal
}))

}

const visibilityHandler = ()=>{
lastTickRef.current = Date.now()
}

document.addEventListener("visibilitychange",visibilityHandler)

const interval = setInterval(flushTime,30000)

return()=>{
clearInterval(interval)
document.removeEventListener("visibilitychange",visibilityHandler)
}

},[user])


useEffect(()=>{

setAnimate(true)

const t = setTimeout(()=>setAnimate(false),250)

return()=>clearTimeout(t)

},[search])


if(loading || !userData) return null


const todayKey = new Date().toLocaleDateString("en-CA")
const todayMinutes = (userData.screentime?.[todayKey] || 0).toFixed(2)

const opportunities = [

{ id:"internshala", name:"Internshala Internships", img:"https://www.google.com/s2/favicons?sz=128&domain=internshala.com" },
{ id:"linkedin", name:"LinkedIn Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=linkedin.com" },
{ id:"wellfound", name:"Wellfound Startups", img:"https://www.google.com/s2/favicons?sz=128&domain=wellfound.com" },
{ id:"indeed", name:"Indeed Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=indeed.com" },
{ id:"glassdoor", name:"Glassdoor Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=glassdoor.com" },
{ id:"devpost", name:"Devpost Hackathons", img:"https://www.google.com/s2/favicons?sz=128&domain=devpost.com" },
{ id:"mlh", name:"MLH Hackathons", img:"https://www.google.com/s2/favicons?sz=128&domain=mlh.io" },
{ id:"unstop", name:"Unstop Competitions", img:"https://www.google.com/s2/favicons?sz=128&domain=unstop.com" },
{ id:"hackerearth", name:"HackerEarth Challenges", img:"https://www.google.com/s2/favicons?sz=128&domain=hackerearth.com" },
{ id:"githubb", name:"GitHub Explore", img:"https://www.google.com/s2/favicons?sz=128&domain=github.com" },

{ id:"gsoc", name:"Google Summer of Code", img:"https://www.google.com/s2/favicons?sz=128&domain=google.com" },
{ id:"leetcode", name:"LeetCode", img:"https://www.google.com/s2/favicons?sz=128&domain=leetcode.com" },
{ id:"hackerrank", name:"HackerRank", img:"https://www.google.com/s2/favicons?sz=128&domain=hackerrank.com" },
{ id:"codeforces", name:"Codeforces", img:"https://www.google.com/s2/favicons?sz=128&domain=codeforces.com" },
{ id:"codechef", name:"CodeChef", img:"https://www.google.com/s2/favicons?sz=128&domain=codechef.com" },
{ id:"coursera", name:"Coursera", img:"https://www.google.com/s2/favicons?sz=128&domain=coursera.org" },
{ id:"edx", name:"edX", img:"https://www.google.com/s2/favicons?sz=128&domain=edx.org" },
{ id:"udemy", name:"Udemy Courses", img:"https://www.google.com/s2/favicons?sz=128&domain=udemy.com" },
{ id:"kaggle", name:"Kaggle Competitions", img:"https://www.google.com/s2/favicons?sz=128&domain=kaggle.com" },
{ id:"freecodecamp", name:"freeCodeCamp", img:"https://www.google.com/s2/favicons?sz=128&domain=freecodecamp.org" },

{ id:"gfg", name:"GeeksforGeeks", img:"https://www.google.com/s2/favicons?sz=128&domain=geeksforgeeks.org" },
{ id:"upwork", name:"Upwork Freelance", img:"https://www.google.com/s2/favicons?sz=128&domain=upwork.com" },
{ id:"fiverr", name:"Fiverr Gigs", img:"https://www.google.com/s2/favicons?sz=128&domain=fiverr.com" },
{ id:"remoteok", name:"Remote OK", img:"https://www.google.com/s2/favicons?sz=128&domain=remoteok.com" },
{ id:"weworkremotely", name:"We Work Remotely", img:"https://www.google.com/s2/favicons?sz=128&domain=weworkremotely.com" },
{ id:"hn", name:"Hacker News", img:"https://www.google.com/s2/favicons?sz=128&domain=ycombinator.com" },
{ id:"devto", name:"Dev.to", img:"https://www.google.com/s2/favicons?sz=128&domain=dev.to" },
{ id:"producthunt", name:"Product Hunt", img:"https://www.google.com/s2/favicons?sz=128&domain=producthunt.com" },
{ id:"techcrunch", name:"TechCrunch", img:"https://www.google.com/s2/favicons?sz=128&domain=techcrunch.com" },

{ id:"mslearn", name:"Microsoft Learn", img:"https://www.google.com/s2/favicons?sz=128&domain=microsoft.com" },
{ id:"gdevelopers", name:"Google Developers", img:"https://www.google.com/s2/favicons?sz=128&domain=developers.google.com" },
{ id:"aws", name:"AWS Training", img:"https://www.google.com/s2/favicons?sz=128&domain=aws.amazon.com" },
{ id:"mitocw", name:"MIT OpenCourseWare", img:"https://www.google.com/s2/favicons?sz=128&domain=mit.edu" },
{ id:"stanfordonline", name:"Stanford Online", img:"https://www.google.com/s2/favicons?sz=128&domain=stanford.edu" },

{ id:"atcoder", name:"AtCoder", img:"https://www.google.com/s2/favicons?sz=128&domain=atcoder.jp" },
{ id:"codesignal", name:"CodeSignal", img:"https://www.google.com/s2/favicons?sz=128&domain=codesignal.com" },
{ id:"topcoder", name:"TopCoder", img:"https://www.google.com/s2/favicons?sz=128&domain=topcoder.com" },
{ id:"spoj", name:"SPOJ", img:"https://www.google.com/s2/favicons?sz=128&domain=spoj.com" },

{ id:"huggingface", name:"Hugging Face", img:"https://www.google.com/s2/favicons?sz=128&domain=huggingface.co" },
{ id:"paperswithcode", name:"Papers With Code", img:"https://www.google.com/s2/favicons?sz=128&domain=paperswithcode.com" },
{ id:"fastai", name:"Fast.ai", img:"https://www.google.com/s2/favicons?sz=128&domain=fast.ai" },
{ id:"deeplearningai", name:"DeepLearning.AI", img:"https://www.google.com/s2/favicons?sz=128&domain=deeplearning.ai" },
{ id:"tensorflow", name:"TensorFlow", img:"https://www.google.com/s2/favicons?sz=128&domain=tensorflow.org" },
{ id:"pytorch", name:"PyTorch", img:"https://www.google.com/s2/favicons?sz=128&domain=pytorch.org" },

{ id:"hackster", name:"Hackster Projects", img:"https://www.google.com/s2/favicons?sz=128&domain=hackster.io" },
{ id:"arduino", name:"Arduino", img:"https://www.google.com/s2/favicons?sz=128&domain=arduino.cc" },
{ id:"raspberrypi", name:"Raspberry Pi", img:"https://www.google.com/s2/favicons?sz=128&domain=raspberrypi.com" },
{ id:"ieee", name:"IEEE", img:"https://www.google.com/s2/favicons?sz=128&domain=ieee.org" },

{ id:"stackOverflowJobs", name:"StackOverflow Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=stackoverflow.com" },
{ id:"turing", name:"Turing Remote Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=turing.com" },
{ id:"arcdev", name:"Arc.dev Remote Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=arc.dev" },
{ id:"flexjobs", name:"FlexJobs", img:"https://www.google.com/s2/favicons?sz=128&domain=flexjobs.com" },

{ id:"roadmapsh", name:"Developer Roadmaps", img:"https://www.google.com/s2/favicons?sz=128&domain=roadmap.sh" },
{ id:"frontendmasters", name:"Frontend Masters", img:"https://www.google.com/s2/favicons?sz=128&domain=frontendmasters.com" },
{ id:"pluralsight", name:"Pluralsight", img:"https://www.google.com/s2/favicons?sz=128&domain=pluralsight.com" },
{ id:"skillshare", name:"Skillshare", img:"https://www.google.com/s2/favicons?sz=128&domain=skillshare.com" },

{ id:"towardsdatascience", name:"Towards Data Science", img:"https://www.google.com/s2/favicons?sz=128&domain=towardsdatascience.com" },
{ id:"medium", name:"Medium Tech Blogs", img:"https://www.google.com/s2/favicons?sz=128&domain=medium.com" },

{ id:"openai", name:"OpenAI Research", img:"https://www.google.com/s2/favicons?sz=128&domain=openai.com" },
{ id:"deepmind", name:"DeepMind Research", img:"https://www.google.com/s2/favicons?sz=128&domain=deepmind.com" },
{ id:"anthropic", name:"Anthropic AI", img:"https://www.google.com/s2/favicons?sz=128&domain=anthropic.com" },

{ id:"gitlab", name:"GitLab Open Source", img:"https://www.google.com/s2/favicons?sz=128&domain=gitlab.com" },
{ id:"bitbucket", name:"Bitbucket", img:"https://www.google.com/s2/favicons?sz=128&domain=bitbucket.org" },

{ id:"replit", name:"Replit Projects", img:"https://www.google.com/s2/favicons?sz=128&domain=replit.com" },
{ id:"vercel", name:"Vercel Platform", img:"https://www.google.com/s2/favicons?sz=128&domain=vercel.com" },
{ id:"netlify", name:"Netlify Deploy", img:"https://www.google.com/s2/favicons?sz=128&domain=netlify.com" },

{ id:"ycombinator", name:"Y Combinator Startup School", img:"https://www.google.com/s2/favicons?sz=128&domain=ycombinator.com" },
{ id:"startupschool", name:"Startup School", img:"https://www.google.com/s2/favicons?sz=128&domain=startupschool.org" },

{ id:"angellist", name:"AngelList Startups", img:"https://www.google.com/s2/favicons?sz=128&domain=angel.co" },
{ id:"naukri", name:"Naukri Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=naukri.com" },
{ id:"monster", name:"Monster Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=monster.com" },
{ id:"dice", name:"Dice Tech Jobs", img:"https://www.google.com/s2/favicons?sz=128&domain=dice.com" },
{ id:"toptal", name:"Toptal Freelance", img:"https://www.google.com/s2/favicons?sz=128&domain=toptal.com" },
{ id:"codecademy", name:"Codecademy", img:"https://www.google.com/s2/favicons?sz=128&domain=codecademy.com" },
{ id:"khanacademy", name:"Khan Academy", img:"https://www.google.com/s2/favicons?sz=128&domain=khanacademy.org" },
{ id:"youtube", name:"YouTube Tutorials", img:"https://www.google.com/s2/favicons?sz=128&domain=youtube.com" },
{ id:"reddit", name:"Reddit Communities", img:"https://www.google.com/s2/favicons?sz=128&domain=reddit.com" },
{ id:"stackoverflow", name:"Stack Overflow", img:"https://www.google.com/s2/favicons?sz=128&domain=stackoverflow.com" },
{ id:"mozilla", name:"Mozilla Developer", img:"https://www.google.com/s2/favicons?sz=128&domain=developer.mozilla.org" },
{ id:"w3schools", name:"W3Schools", img:"https://www.google.com/s2/favicons?sz=128&domain=w3schools.com" },
{ id:"mdn", name:"MDN Web Docs", img:"https://www.google.com/s2/favicons?sz=128&domain=developer.mozilla.org" },
{ id:"bootstrap", name:"Bootstrap", img:"https://www.google.com/s2/favicons?sz=128&domain=getbootstrap.com" },
{ id:"tailwindcss", name:"Tailwind CSS", img:"https://www.google.com/s2/favicons?sz=128&domain=tailwindcss.com" },
{ id:"reactjs", name:"React Docs", img:"https://www.google.com/s2/favicons?sz=128&domain=reactjs.org" },
{ id:"vuejs", name:"Vue.js", img:"https://www.google.com/s2/favicons?sz=128&domain=vuejs.org" },
{ id:"angular", name:"Angular", img:"https://www.google.com/s2/favicons?sz=128&domain=angular.io" }

]


const filtered = opportunities.filter(o =>
o.name.toLowerCase().includes(search.toLowerCase())
)


return(

<div className="explore-container">

<div className="branch-panel">
<h2>Your Branch</h2>
<p>{userData.branch || "Not Set"}</p>
<p className="screen-info">Today Screentime: {todayMinutes} minutes</p>
</div>

<div className="explore-panel">

<h3>Global Opportunities</h3>

<p className="explore-sub">
Internships, hackathons, competitions, remote jobs, coding practice,
AI/ML platforms and learning resources.
</p>

<input
type="text"
placeholder="Search opportunities..."
className="explore-search"
value={search}
onChange={(e)=>setSearch(e.target.value)}
/>

<div className={`explore-grid ${animate ? "search-animate" : ""}`}>

{filtered.map((item,index)=>{

const loaded = loadedImages[index]

return(
<button
key={item.id}
className="explore-card"
onClick={()=>navigate(`/dashboard/opportunityblog?name=${item.id}`)}
>

{!loaded && <div className="explore-skeleton"></div>}

<img
src={item.img}
alt={item.name}
className={loaded ? "explore-img show" : "explore-img hide"}
onLoad={()=>setLoadedImages(prev=>({...prev,[index]:true}))}
onError={e=>{
e.target.src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
setLoadedImages(prev=>({...prev,[index]:true}))
}}
/>

<span>{item.name}</span>

</button>
)

})}

</div>

</div>

</div>

)

}

export default Explore